import React from "react";

const HeroSection = () => {
  return (
    <div className="hero_home version_1">
      <div className="content">
        <h3>Find a Doctor!</h3>
        <p>Book an Appointment with Expert Surgeons.</p>
        <form method="post" action="list.html">
          <div id="custom-search-input">
            <div className="input-group">
              <input type="text" className="search-query" placeholder="Ex. Name, Specialization ...." />
              <input type="submit" className="btn_search" value="Search" />
            </div>
            <ul>
              <li>
                <input type="radio" id="all" name="radio_search" defaultChecked />
                <label htmlFor="all">All</label>
              </li>
              <li>
                <input type="radio" id="doctor" name="radio_search" />
                <label htmlFor="doctor">Doctor</label>
              </li>
              {/* <li>
                <input type="radio" id="clinic" name="radio_search" />
                <label htmlFor="clinic">Clinic</label>
              </li> */}
            </ul>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HeroSection;
